import './routeBreadcrumb.scss';
import { Typography, Stack } from '@mui/material';
import { Stop, StopType, StopStatus } from '../../apis/dtos';

interface RouteBreadcrumbProps {
  stop: Stop;
  nextStop: Stop | undefined;
}

type ConnectorClassName = 'blue-dash' | 'blue-solid';
type IconClassName =
  | 'checkmark'
  | 'filled-location'
  | 'empty-location'
  | 'blue-empty-location';

// TODO: Determine all of the scenarios and what to display for each here.

export const RouteBreadcrumb = ({ stop, nextStop, }: RouteBreadcrumbProps) => {
  let beforeClass: ConnectorClassName = 'blue-dash';
  let afterClass: ConnectorClassName = 'blue-dash';
  let iconClass: IconClassName = nextStop == null ? 'empty-location' : 'blue-empty-location';

  switch (stop?.stopStatus) {
    case StopStatus.Completed:
      beforeClass = 'blue-solid';
      afterClass = 'blue-solid';
      iconClass = nextStop == null ? 'filled-location' : 'checkmark';
      break;

    case StopStatus.Current:
      iconClass = nextStop == null ? 'filled-location' : 'checkmark';
      if (nextStop && nextStop?.stopType === StopType.Pick) {
        afterClass = 'blue-solid';
      }
      break;
  }

  return (
    <Stack className="route-crumb" data-testid="route-crumb">
      <Typography component="div" className={`connector ${beforeClass}`} data-testid="connector-before" />
      <Typography component="span" className={`icon ${iconClass}`} data-testid="icon" />
      <Typography component="div" className={`connector ${afterClass}`} data-testid="connector-after" />
    </Stack>
  );
};